import { i18n } from '@/api/i18n'
/// <summary>
/// 发货完成
/// </summary>
export const SHIPPED = 2
export const FINISH_SHIPMENT_STATUS = 20//  非客单发货完成状态
// 报废完成
export const SCRAPPED = 3
export const FINISH_SCRAP_STATUS_N = 21//  非客单报废完成状态
export const FINISH_SCRAP_STATUS = 23//  非客单报废完成状态
// ECLP订单可报废状态
export const ECLPSCRAPP = 5
// POP订单指定报废状态
export const POPSCRAPP = 6

export const OB_CHECK = 'obCheck'
export const YES_CODE = 1
export const NO_CODE = 0
export const YES_VALUE = i18n.t('yes')
export const NO_VALUE = i18n.t('no')
export const INVOICE_PRINT = i18n.t('invoicePrint') // "已开";
export const BILL_PRINT = i18n.t('printed')// "已打印";
export const BILL_UNPRINT = i18n.t('unPrint')// "未打印";
export const SigleCheck = '1'
export const PIECE_TYPE_SMALL = 'small'
export const TREATY_TYPE_DEFAULT = '-1' // 非订单合约类型
export const BOX = i18n.t('box')// "箱";
export const PIECES = i18n.t('piece')// "件";

export const INVOICE_PRINT_LINES = 7 // 默认打印发票明细的行数
export const INVOICE_PRINT_KYE = 'INVOICE_PRINT_LINES' // 发票打印的行数
export const DIFFBTN_ENABLED = 'SCRAP_BUTTON'// 差异是否可用
export const CONSUME_SUPPORT_KYE = 'ispackagingrecommendation'// 包裹打包是否启用"耗材推荐"
export const SCANNING_CONSUME_KYE = 'is_Scanning_consumables'// 包裹打包是否启用"耗材扫描"

export const CHECK_STYLE_NOMAL = 1 // 一般复核
export const CHECK_STYLE_REBIN = 2 // Rebin复核
export const CHECK_STYLE_PACK = 3 // 一般复核 + 打包

export const PACK_TYPE_ONLY = 1 // 独立打包
export const PACK_TYPE_CHECK = 2 // 复核打包一体化
export const PACK_TYPE_WALL = 4 // 分选复核打包
export const EXPLOSIVE_RECHECK_PACKAGE = 3 //爆品复核打包

export const TWO_D_IMAGE_FLAG = '2DImage'// 二维码占位标记
export const INVOICE_PRIX = 'invoice'// 发票文件前缀
export const INVOICE_DETAIL_PRIX = 'invoiceDetail'// 发票明细文件前缀

export const USE_PRINTLINE_SWITCH = false // 启用获取Master发票打印行数
export const INVOICE_TEMPLATE_SWITCH = false // 只取一次master
export const INVOICE_ORG = '' // ERP机构号，用于打印发票
export const USE_PRINT_INVOICE = false // 启用发票打印
export const USE_SCAN_CONSUMBLES = false // 启用批量耗材扫描
export const USE_SCAN_ONE = false // 启用逐个扫描
export const USE_CHECK_PACKAGE = false // 启用复核打包一体化
export const USE_DEFAULT_CONSUMBLE = false// 启用默认耗材（无需扫描耗材）
export const USE_ONE_PACKAGE = false // 启用默认单一包裹
export const USE_PACKAGE_WEIGHT = false // 启用打包称重
export const USE_CHECK_INVOICE = false // 启用发票校验
export const USE_AUTOSHOW_PACKDETAIL = false // 启用自动显示打包明细
export const USE_PACKAGEDETAIL_SCAN = false // 启用包裹明细扫描
export const DEFAULT_CONSUMABLE_CODE = String.Empty // 默认使用的耗材编码
export const DEFAULT_CONSUMABLE_NAME = String.Empty // 默认使用的耗材名称
export const USE_REBIN_PRINT_INVOCE = String.Empty // Rebinwall复核打印发票

// 复核号对应的节点名称（与配置文件节点名称对应）
export const PLATFORM_NO_NORMAL = 'PlatformNo_Normal' // 一般订单
export const PLATFORM_NO_REBINWALL = 'PlatformNo_RebinWall' // RebinWall复核
export const PACK_TABLE_NO = 'pack_talbe_no' // RebinWall复核打包台号
export const FORM_SET_USE_SCAN_ONE = 'use_scan_one' // 启用逐个扫描商品编码
export const FORM_SET_USE_PRINT_INVOICE = 'use_print_invoice' // 启用复核打印发票
export const FORM_SET_USE_CHECK_PACKAGE = 'use_check_package' // 启用复核打包
export const FORM_SET_USE_CHECK_INVOICE = 'use_check_invoice' // 启用发票校验
export const FORM_SET_USE_DEFAULT_CONSUMBLE = 'use_default_consumble'// 启用默认耗材（复核、打包是无需扫描耗材）
export const FORM_SET_USE_ONE_PACKAGE = 'use_one_package' // 启用默认耗材（复核、打包是无需扫描耗材）
export const FORM_SET_USE_PACKAGE_WEIGHT = 'use_package_weight'// 启用包裹称重
export const FORM_SET_USE_AUTOSHOW_PACKDETAIL = 'use_autoshow_packagedetail'// 启用自动显示打包耗材明细
export const FORM_SET_USE_PACKAGEDETAIL_SCAN = 'use_packagedetail_scan'// 启用包裹明细扫描
export const FORM_SET_USE_SCAN_CONSUMABLES = 'use_scan_consumables' // 启用批量耗材扫描
export const FORM_SET_DEFAULT_CONSUMABLE_CODE = 'default_consumable_code'// 默认耗材编码
export const FORM_SET_DEFAULT_CONSUMABLE_NAME = 'default_consumable_name'// 默认耗材名称
export const FORM_SET_USE_PRINT_INVOCE_REBIN = 'use_print_invoice_rebin' // Rebinwall复核打印发票
export const FORM_SET_INVOICE_PRINT_LINES = 'invoice_print_lines' // 发票打印的行数
export const FORM_SET_CONTAINER_CODE_TYPE = 'Container_Code_Type' // 容器编码规则

export const USE_PLATFORM_NO_NORMAL = String.Empty // 普通复合台
export const USE_PACK_TABLE_NO = String.Empty// 打包台

// B2B复核台
export const PLATFORM_NO_B2B = 'PlatformNo_B2B' // B2B本地配置文件复核台Key
export const FORM_SET_B2B_SCAN_ON = 'b2b_scan_one' // B2B本地配置文件逐个扫描Key
export const FORM_SET_B2B_PRINT_LIST = 'b2b_print_list' // B2B本地配置文件打印发货箱明细Key
export const USE_PLATFORM_NO_B2B = String.Empty// B2B复合台
export const USE_SCAN_ONE_B2B = false // 逐个扫描
export const USE_PRINT_DETAIL_B2B = false // 打印箱明细

// 样品出库
export const PLATFORM_NO_SAMPLE = 'PlatformNo_Sample' // 样品本地配置文件复核台Key
export const FORM_SET_SAMPLE_SCAN_ON = 'sample_scan_one' // 样品本地配置文件逐个扫描Key
export const FORM_SET_SAMPLE_PRINT_LIST = 'sample_print_list' // 样品本地配置文件打印发货箱明细Key
export const USE_PLATFORM_NO_SAMPLE = String.Empty// 样品出库复核台
export const USE_SCAN_NOE_SAMPLE = false// 逐个扫描
export const USE_PRINT_DETAIL_SAMPLE = false// 打印箱明细

// 退供复核
export const PLATFORM_NO_BACK_TO_OWNER = 'PlatformNo_Back_To_Owner' // 退供应商订单、赠品订单本地配置文件复核台Key
export const FORM_SET_BACK_TO_OWNER_SCAN_ON = 'back_to_owner_scan_one' // 退供应商复核本地配置文件逐个扫描Key
export const FORM_SET_BACK_TO_OWNER_PRINT_LIST = 'back_to_owner_print_list' // 退供应商复核本地配置文件打印发货箱明细Key
export const USE_PLATFORM_NO_TO_OWNER = String.Empty// 退供应商复核台
export const USE_SCAN_ONE_TO_OWNER = false// 逐个扫描
export const USE_PRINT_DETAIL_TO_OWNER = false // 打印箱明细

// 大库出备件库复核
export const PLATFORM_NO_BIG_STORE = 'PlatformNo_Big_Store' // 大库出备件库订单本地配置文件复核台Key
export const FORM_SET_BIG_STORE_USE_WEIGHT = 'big_store_use_weight' // 大库出备件库启用登记商品扩展信息
export const FORM_SET_BIG_STORE_USE_REGISTER = 'big_store_use_register'// 大库出备件库启用登记商品扩展信息
export const USE_PLATFORM_NO_BIG_STOR = String.Empty// 大库出备件库复核台
export const USE_FORM_SET_BIG_STORE_USE_WEIGHT = false// 启用称重
export const USE_FORM_SET_BIG_STORE_USE_REGISTER = false // 启用登记

export const SELF_SUPPORT_FLAG = '4' // 配送类型（京东自营）
export const SCAN_CODE_TYPE_BARCODE = 1 // 扫码类型（商品条码、UPC码）
export const SCAN_CODE_TYPE_SERIAL = 3 // 扫码类型（序列号）
export const SCAN_CODE_TYPE_BOXNO = 6 // 扫码类型(箱码')

export const CARRIER_NO_IS_QL = 'CYS0000010' // 承运商CYS0000010为青龙配送

// 打印机设置
// public static List<PrintConfig> ListPrinterSet = null;
export const ORDER_PAGE_NUMBER = 6 // 打印面单的商品行数
export const SHOP_LIST_COUNT = 6 // 设置购物清单打印行数
export const PRINT_MODEL_ORDER = 'order' // 默认打印机：面单
export const PRINT_MODEL_INVOICE = 'invoice' // 默认打印机：发票
export const PRINT_ORDER_LIST = 'orderList' // 默认打印机：打印购物清单
export const PRINT_BUSINESS_PAPER = 'paperPurchase' // 默认打印机：商采三联单
export const PRINT_PEPERLESS_PACK = 'paperlessPackage'// 默认打印机：无纸化包裹标签
export const PRINT_GREETING_CARD = 'greetingCard'// 默认打印机：贺卡打印
export const PRINT_SHIP_EIR = 'shipEIR' // 协同仓发货交接单shipEIR
export const PRINT_B2B_BOX = 'b2bBox'// B2B箱签打印
export const PRINT_B2B_BOXLIST = 'b2bBoxList'// B2B箱签打印
export const PRINT_B2B_SHIP_EIR = 'b2bShipEIR'// B2B发货交接单
export const PRINT_MEDICINE_ORDERLIST = 'medicineOrderList'// 货票随行单打印
export const PRINT_SAMPLE_BOXLABLE = 'sampleboxlable'// 样品出库箱签打印机
export const PRINT_SAMPLE_HANDOVER = 'samplehandover'// 样品出库交接单打印机
export const RECOMMEND_BOX_NUM = 3// 显示推荐箱号的数量（退供应商、赠品复核）
export const MAX_BOX_NUM = 5 // 超过此数量后，不允许生成新的箱号
export const SUCCESS_CODE = 1// 返回成功编码
export const FAILED_CODE = 0 // 返回失败编码
export const NULL_CODE = 2 // 返回空值编码
export const ERROR_CODE = -1 // 返回错误编码
// export const DATA_NULL_CODE = 1800019;   //返回空值编码
// export const MASTER_NULL_CODE = 1801044;   //MASTER返回空值编码
// 复核号标记
export const CHECK_NORMAL = 'Check_Normal' // 一般订单
export const CHECK_CONTRACT = 'Check_Contract' // 合约订单

export const PLATFORM_TYPE_VALUE_NORMAL = '50702010' // 一般订单复核类型
export const PLATFORM_TYPE_VALUE_PLENTY = '50702009' // 大宗订单复核类型
export const PLATFORM_TYPE_VALUE_BIG_STORE = '50702004' // 大库出备件库复核类型
export const PLATFORM_TYPE_VALUE_BACK_TO_OWNER = '50702005' // 退供应商
export const PLATFORM_TYPE_VALUE_GIFTS = '50702007' // 赠品复核类型
export const PLATFORM_TYPE_VALUE_REBINWALL = '50702011' // RebinWall复核
export const PLATFORM_TYPE_VALUE_B2B = '50702020' // B2B订单  (未定义')
export const PLATFORM_TYPE_VALUE_PARALLEL = '50702021' // 货票同行复核类型
export const PLATFORM_TYPE_VALUE_SUBSIDY = '50702022' // 节能补贴复核类型
export const PLATFORM_TYPE_VALUE_SURPRISE = '50702023' // 惊喜送复核类型
export const PLATFORM_TYPE_VALUE_SAMPLE = '50702006' // 样品复核类型
export const PLATFORM_TYPE_VALUE_SHAREBUY = '60702018' // 拼购复核类型
export const PLATFORM_TYPE_VALUE_SITEPRE = '60702019' // 站点复核类型
export const PLATFORM_TYPE_VALUE_SITEREDUCE = '60702020' // 站点降级复核类型

export const EQUIMETN_TYPE_CHECK = 'review_site' // 设备类型：复核台
export const EQUIMETN_TYPE_PACKING = 'pkMachine' // 设备类型：打包台

export const QUERY_TYPE_INVOICE = 'invoice' // 发票前打
export const QUERY_TYPE_BILL = 'bill' // 面单前打

// Service 调用Token信息
// export const WEBSERVICE_URL = AppSettings.GetWebServiceURL('WebServiceUrl', 'ObCheck'')
// export const CALL_CODE = AppSettings.GetWebServiceURL('CallCode', 'ObCheck'')// 用户调用码
// export const UUID = AppSettings.GetWebServiceURL('uuid', 'ObCheck'') // UUID

// 订单类型
export const OUTBOUND_TYPE_SHAREBUY = 6 // 拼购订单
export const OUTBOUND_TYPE_CUSTOME = 10 // 普通订单
export const OUTBOUND_TYPE_PLENTY = 18 // 大宗订单
export const OUTBOUND_TYPE_BUSINESS = 26 // 商采订单
export const OUTBOUND_TYPE_BIG_STORE = 12 // 大库出备件库
export const OUTBOUND_TYPE_BACK_TO_OWNER = 13 // 退供应商
export const OUTBOUND_TYPE_SAMPLE = 14 // 样品出库
export const OUTBOUND_TYPE_GIFTS = 15 // 赠品
export const OUTBOUND_TYPE_SCRAP_TO_OWNER = 19// 报废单
export const OUTBOUND_TYPE_B2B = 27 // B2B订单
export const OUTBOUND_TYPE_TRANSFER = 70 // 调拨出

// 订单状态
export const STATUS_CHECKING = -1 // 操作中状态
export const STATUS_INIT = 0 // 初始化状态
export const STATUS_LOCKED = 1 // 锁定状态
export const STATUS_FINISHED = 2 // 复核完成
export const STATUS_DIFFER_CHECK = 3 // 复核登记差异
export const STATUS_DIFFER_PICK = 4 // 拣货登记差异
export const STATUS_CANCEL = 404 // 取消的订单
export const STATUS_TROUBLE = 120 // 转成病单的订单
export const STATUS_PACK_FINISHED = 10 // 订单打包完成
export const STATUS_PACK_CANCEL = 11 // 打包拦截取消订单，未打印“逆向退货标签”
export const STATUS_PACK_CANCEL_PRINT = 12// 打包拦截取消订单，已打印“逆向退货标签”

export const STATUS_PACKAGED = 70 // OTM中订单打包完成状态
export const STATUS_SELECTED = 1 // 选中复核中

// master定义的容器类型
export const CONTAINER_TYPE_PALLET = 'pallet' // 托盘
export const CONTAINER_TYPE_BOX = 'box' // 周装箱
export const CONTAINER_TYPE_PICKING_CAR = 'picking_car' // 拣货车
export const CONTAINER_TYPE_REBIN_CAR = 'rebin_car' // Rebin车

// 仓库常量配置信息
export const PART_STORE_BREAK_TYPE = 'PART_STORE_BREAK_TYPE'// 破损类型
export const REBIN_GRID_QTY = 'REBIN_GRID_QTY'// Rebin格子数量配置
export const CONTAINER_TYPE = 'containerType' // 容器类型配置

// 订单类型名称
export const OUTBOUND_TYPE_NAME_CUSTOME = i18n.t('outboundTypeNameCustome')// "普通订单";
export const OUTBOUND_TYPE_NAME_BUSINESS = i18n.t('outboundTypeNameBusiness')// "商采订单";
export const OUTBOUND_TYPE_NAME_BACK_TO_OWNER = i18n.t('outboundTypeNameBackToOwner')// "退供应商";
export const OUTBOUND_TYPE_NAME_BIG_STORE = i18n.t('outboundTypeNameBigStore')// "大库出备件库";
export const OUTBOUND_TYPE_NAME_GIFTS = i18n.t('outboundTypeNameGifts')// "赠品出库单";
export const OUTBOUND_TYPE_NAME_SCRAP_TO_OWNER = i18n.t('outboundTypeNameScrapToOwner')// "报废单";
export const OUTBOUND_TYPE_NAME_B2B = i18n.t('outboundTypeNameB2b')// "B2B订单";
export const OUTBOUND_TYPE_NAME_SAMPLE = i18n.t('outboundTypeNameSample')// "图书借用单";
export const OUTBOUND_TYPE_NAME_TRANSFER = i18n.t('transferOutbound')// "调拨出库";

// 订单提货方式
export const OUTBOUND_SEND_TYPE_TC = i18n.t('outboundSendTypeTc')// "TC配送";
export const OUTBOUND_SEND_TYPE_SELF = i18n.t('outboundSendTypeSelf')// "商家自提";
export const OUTBOUND_SEND_TYPE_SEND = i18n.t('outboundSendTypeSend')// "库房主发";
export const OUTBOUND_SEND_TYPE_TRANS = i18n.t('outboundSendTypeTrans')// "商家转自营";

// 承运商类型
export const CARRIERTYPE_JD = 1
export const CARRIERTYPE_JDTOTHIRD = 2
export const CARRIERTYPE_THIRD = 3

// 三方类型
export const CARRIERSUBTYPE_SF = 1// 丰顺
export const CARRIERSUBTYPE_CN = 2// 菜鸟
export const CARRIERSUBTYPE_ST = 3// 申通
export const CARRIERSUBTYPE_YT = 4// 圆通
export const CARRIERSUBTYPE_ZT = 5// 中通

/// <summary>
/// 正确、true
/// </summary>
export const YES = 1
/// <summary>
/// 错误、失败
/// </summary>
export const NO = 0
/// <summary>
/// 是否显示报废按钮标示
/// </summary>
export const SCRAPBUTTONKEY = 'SCRAP_BUTTON'
export const SUPPLIERSENDTYPE = 'supplier_sendType'
export const SUPPLIERDAY = 'SUPPLIER_DAY'

export const STATUS_ECLP_SCRAP = '5' // 接收ECLP报废通知
/// <summary>
/// 默认显示报废,1-显示，0不显示
/// </summary>
export const SCRAPBUTTON = 1
export const SCRAPDEADLINE = 12

/// <summary>
/// 自营订单
/// </summary>
export const SOURCE_ERP = '1'
/// <summary>
/// ECLP订单
/// </summary>
export const SOURCE_ECLP = '6'

/// <summary>
/// 商家转自营(ECLP')
/// </summary>
export const ECLPTRANS_INDEX = 4
export const ECLPTRANS_NAME = i18n.t('outboundSendTypeTrans')// "商家转自营";
/// <summary>
/// 库房主发(ECLP')
/// </summary>
export const WAREHOUSESEND_INDEX = 3
export const WAREHOUSESEND_NAME = i18n.t('outboundSendTypeSend')// "库房主发";

/// <summary>
/// 商家自提(ECLP')
/// </summary>
export const SELLERPICKUP_INDEX = 2
export const SELLERPICKUP_NAME = i18n.t('outboundSendTypeSelf')// "商家自提";

/// <summary>
/// TC配送(ECLP')
/// </summary>
export const TCSEND_INDEX = 1
export const TCSEND_NAME = i18n.t('outboundSendTypeTc')// "TC配送";

/// <summary>
/// 根据索引获取对应的值(ECLP')
/// </summary>
export const SupplierSendName =
        {
          1: TCSEND_NAME,
          2: SELLERPICKUP_NAME,
          3: WAREHOUSESEND_NAME,
          4: ECLPTRANS_NAME
        }

/// <summary>
/// 根据索引获取对应的值(ERP')
/// </summary>
export const SupplierSendNameErp =
        {
          1: WAREHOUSESEND_NAME,
          2: SELLERPICKUP_NAME
        }

// 报表查询方式
export const REPORT_QUERY_TYPE_PACK_MSG = i18n.t('reportQueryTypePackMsg')// "打包积压";
export const REPORT_QUERY_TYPE_CHECK_MSG = i18n.t('reportQueryTypeCheckMsg')// "复核积压";
export const REPORT_QUERY_TYPE_PACK_CODE = 1
export const REPORT_QUERY_TYPE_CHECK_CODE = 0

// 退供、报废单临期提示
export const BACK_TO_OWNER_SELF_SOURCE_A = '7' // 常规临期
export const BACK_TO_OWNER_SELF_SOURCE_B = '9' // 常规临期
export const SCRAP_TO_OWNER_TYPE_A = '13' // 临期不可退报废
export const SCRAP_TO_OWNER_TYPE_B = '14' // 临期残次品报废

// // 图片存放地址
// export const IMAGE_FOLDER_ADDRESS = AppDomain.CurrentDomain.BaseDirectory + 'Template\\TmpBarcodeFile\\arrow.gif'

// // 语音存放地址
// export const SUCCESS_MEDIA_FOLDER_ADDRESS = AppDomain.CurrentDomain.BaseDirectory + 'Template\\packagedSuccess.wav'
// export const FAILED_MEDIA_FOLDER_ADDRESS = AppDomain.CurrentDomain.BaseDirectory + 'Template\\packagedFail.wav'

// 大库出备件库标识（用户标签打印）
export const WAREHOUSE_CODE_SPARE = 'BJK'
export const WAREHOUSE_NAME_SPARE = i18n.t('warehouseNameSpare')// "备件库";

// 消息提示
export const MESSAGE_REMOTE_CONNECTION_ERROR = i18n.t('messageRemoteConnectionError')// "连接远程服务失败！";

// RebinWall客户端设置
// public static ClientSettings CLIENT_SETTINGS = null;

// 离线发票
export const offlineInvo = 2

// 交接初始状态，未打印交接单
export const SHIPMENT_STATUS_INIT = 1
// 已打印交接单，待交接
export const SHIPMENT_STATUS_PRINT = 2
// 已交接，待发货
export const SHIPMENT_STATUS_HANDS = 3
// 发货完成
export const SHIPMENT_STATUS_FINISH = 4

// 企业用户
export const CORPORATE = ['-101']

// PLUS会员
export const USERLEVELID = ['101', '201', '62', '105', '110']

// PLUS会员显示备注级别
export const PLUSUSER_REMARK = [ '101', '201' ]

// 交接单打印类型
/// <summary>
/// 退供应商
/// </summary>
export const SUPPLIER_PRINT_TYPE = '21'

/// <summary>
/// 出备件库
/// </summary>
export const REPAIR_PRINT_TYPE = '22'

/// <summary>
/// 赠品
/// </summary>
export const GIFT_PRINT_TYPE = '24'

/// <summary>
/// 样品
/// </summary>
export const SPECIMEN_PRINT_TYPE = '23'

/// <summary>
/// 打包耗材扫描类型-默认
/// </summary>
export const PACKAGE_CONS_SCAN_TYPE_DEFAULT = '0'

/// <summary>
/// 打包耗材扫描类型-耗材扫描
/// </summary>
export const PACKAGE_CONS_SCAN_TYPE_CONS = '1'

/// <summary>
/// 打包耗材扫描类型-包裹明细扫描
/// </summary>
export const PACKAGE_CONS_SCAN_TYPE_DETAIL = '2'

/// <summary>
/// ITMS的cartonUrl {0}为包裹号占位符
/// </summary>
export const ITMS_CARTONURL = 'itms_cartonUrl'

/// <summary>
/// ITMS的orderURL {0}为订单号占位符
/// </summary>
export const ITMS_ORDERURL = 'itms_orderURL'

/// <summary>
/// 印尼环境SystemId
/// </summary>
export const SYSTEMID_ID = 'ID'

/// <summary>
/// 泰国环境SystemId
/// </summary>
export const SYSTEMID_TH = 'TH'

/// <summary>
/// 美国环境SystemId
/// </summary>
export const SYSTEMID_US = 'US'

/// <summary>
/// common环境SystemId
/// </summary>
export const SYSTEMID_COMMON = 'COMMON'

/// <summary>
/// 海外直邮
/// </summary>
export const SYSTEMID_CLOUD = 'CLOUD'

/// <summary>
/// EPT
/// </summary>
export const SYSTEMID_EPT = 'EPT'

/// <summary>
///在线信用卡支付
/// </summary>
export const ONLINE = "ONLINE";
/// <summary>
///货到付款
/// </summary>
export const COD = "COD";
/// <summary>
///银行转账
/// </summary>
export const Transfer = "Transfer";
/// <summary>
///预付款支付方式
/// </summary>
export const IOU = "IOU";
/// <summary>
///印尼第三方贷款支付，需要收货时传收获照片
/// </summary>
export const MF = "MF";
/// <summary>
///MF_PHOTO
/// </summary>
export const MF_PHOTO = "MF_PHOTO";
/// <summary>
///INSTALLMENT
/// </summary>
export const INSTALLMENT = "INSTALLMENT";
/// <summary>
///虚拟充值
/// </summary>
export const POP = "POP";
/// <summary>
///电影票充值
/// </summary>
export const TCK = "TCK";
/// <summary>
///O2O订单
/// </summary>
export const O2O = "O2O";
/// <summary>
///PLANE
/// </summary>
export const PLANE = "PLANE";
/// <summary>
///VSP场景1：企业为员工提供福利，使员工按照企业优惠价购买商品
/// </summary>
export const VSP_1 = "VSP_1";
/// <summary>
///VSP场景2：一个企业多个采购员使用企业白条进行采购
/// </summary>
export const VSP_2 = "VSP_2";
/// <summary>
///酒店支付
/// </summary>
export const HOTEL = "HOTEL";

/// <summary>
///{0} {1}线
/// </summary>
export const packText = "packText";

/// <summary>
///航
/// </summary>
export const air = "air";
/// <summary>
///半
/// </summary>
export const self = "self";
/// <summary>
///催
/// </summary>
export const urge = "urge";
/// <summary>
///合
/// </summary>
export const combine = "combine";
/// <summary>
///柜
/// </summary>
export const cabinet = "cabinet";
/// <summary>
///店
/// </summary>
export const store = "store";
/// <summary>
///提
/// </summary>
export const carry = "carry";
/// <summary>
///集
/// </summary>
export const collection = "collection";
/// <summary>
///城
/// </summary>
export const city = "city";
/// <summary>
///安
/// </summary>
export const safety = "safety";
/// <summary>
///众
/// </summary>
export const crowd = "crowd";
/// <summary>
///礼
/// </summary>
export const gift = "gift";
/// <summary>
///赠
/// </summary>
export const present = "present";
/// <summary>
///促
/// </summary>
export const promotion = "promotion";
/// <summary>
///贵
/// </summary>
export const expensive = "expensive";
/// <summary>
///大
/// </summary>
export const big = "big";
/// <summary>
///奢
/// </summary>
export const extravagant = "extravagant";
/// <summary>
///商
/// </summary>
export const business = "business";
/// <summary>
///普
/// </summary>
export const general = "general";
/// <summary>
///电
/// </summary>
export const electric = "electric";
/// <summary>
///京东试用
/// </summary>
export const JDTrial = "JDTrial";
/// <summary>
///新
/// </summary>
export const new2 = "new2";
/// <summary>
///企
/// </summary>
export const enterprise = "enterprise";
/// <summary>
///一
/// </summary>
export const one = "one";
/// <summary>
///节能补贴
/// </summary>
export const energySaving = "energySaving";
/// <summary>
///红通抽检
/// </summary>
export const redPassCheck2 = "redPassCheck2";
/// <summary>
///绿通抽检
/// </summary>
export const greenPassCheck2 = "greenPassCheck2";
/// <summary>
///请开箱验货;
/// </summary>
export const unpackExamineCargo = "unpackExamineCargo";
/// <summary>
///请本人签收;
/// </summary>
export const oneselfSignIn = "oneselfSignIn";
/// <summary>
///高
/// </summary>
export const height = "height";
/// <summary>
///闪
/// </summary>
export const quick = "quick";
/// <summary>
///无
/// </summary>
export const none = "none";
/// <summary>
///京准达
/// </summary>
export const JDOntime = "JDOntime";
/// <summary>
///211 早
/// </summary>
export const morning211 = "morning211";
/// <summary>
///211 午
/// </summary>
export const noon211 = "noon211";
/// <summary>
///次日达
/// </summary>
export const nextDayArrive = "nextDayArrive";
/// <summary>
///隔日达
/// </summary>
export const thirdDayArrive = "thirdDayArrive";
/// <summary>
///4日达
/// </summary>
export const fourthDayArrive = "fourthDayArrive";
/// <summary>
///5日达
/// </summary>
export const fifthDayArrive = "fifthDayArrive";
/// <summary>
///6日达
/// </summary>
export const sixthDayArrive = "sixthDayArrive";
/// <summary>
///7日达
/// </summary>
export const seventhDayArrive = "seventhDayArrive";
/// <summary>
///8+日达
/// </summary>
export const eighthDayArrive = "eighthDayArrive";
/// <summary>
///保留此包裹联时，代表您已经签收并确认配送商品信息。 0J0D
/// </summary>
export const keepThePackageUniteSignInConfirm = "keepThePackageUniteSignInConfirm";
/// <summary>
///保留此包裹联时，代表您已经签收并确认配送商品信息。客服须知及退货流程请登录 http://help.jd.com
/// </summary>
export const keepThePackageUniteSignInConfirmCustomerService = "keepThePackageUniteSignInConfirmCustomerService";
/// <summary>
///保留此包裹联时，代表您已经签收并确认配送商品信息。本运单由京东提供物流服务，商品物权归商家所有，并由商家提供售后服务
/// </summary>
export const keepThePackageUniteSignInConfirmStatement = "keepThePackageUniteSignInConfirmStatement";

/**
 * 设置复合台号Key
 * @type {string}
 */
export const PLATFORM_NO_KEY = 'strPlatformNo';

/**
 * 设置复合台号Key
 * @type {string}
 */
export const DEFAULT_STATION_TYPE = 'DEFALUT001';

/**
 * 原包装耗材UPC
 * @type {string}
 */
export const ORIGINAL_PACKAGING_SUPPLIES_UPC = 'SIOP';
/**
 * 耗材缠膜
 * @type {string}
 */
export const STRETCHWRAP = 'STRETCHWRAP';
/**
 * 耗材缠膜
 * @type {string}
 */
export const SIOPBAG = 'SIOPBAG';


/// <summary>
/// 仓是否按商品编码 + 序列号进行校验序列号商品出库;1 为开启 0 为关闭
/// </summary>
export const CHECK_GOODS_AND_SERIAL_CODE = 'CHECK_GOODS_AND_SERIAL_CODE'
export const CHECK_GOODS_AND_SERIAL_CODE_FLAG = '1'

/// <summary>
/// 允许唯一码二次出库 1 为开启 0 为关闭
/// </summary>
export const ALLOW_UNIQUE_CODE_SECONDAY_DELIVERY = 'ALLOW_UNIQUE_CODE_SECONDAY_DELIVERY'

/// <summary>
/// 系统参数通用值 是为1
/// </summary>
export const SYSTEM_PARAM_VALUE_YES = '1'

/// <summary>
/// 系统参数通用值 是为0
/// </summary>
export const SYSTEM_PARAM_VALUE_NO = '0'


/// <summary>
/// 原包默认耗材
/// </summary>
export const ORI_CONSUMABLES = 'ORI_CONSUMABLES'


/// <summary>
/// 尾程单号截取分隔字符
/// </summary>
export const TRAIL_SPLIT_CHAR = 'TRAIL_SPLIT_CHAR'


/// <summary>
/// 是否启用CC新包裹标签打印
/// </summary>
export const NEW_CC_PACKAGE_FLAG = 'NEW_CC_PACKAGE_FLAG'


/// 组托采集方式
export const b2boutBoundPalletCollectingWay = 'b2boutBoundPalletCollectingWay'

export const HKM_CALL_FAIL_HANDLE_TYPE = 'hkm_call_fail_handle_type'

/// 二维码形式批量唯一码
export const isBatchUniqueCodeByQRcode = 'isBatchUniqueCodeByQRcode'

/// 二维码唯一码截取规则(正则)。当扫描枪扫描二维码/二维码生成时未带回车或空格，
/// 导致分隔符匹配不生效、多个唯一码粘连成超长字符串时，
/// 使用该正则按规则拆分。仅当该参数有值且能成功转成正则时生效。
export const BATCH_UNIQUE_CODE_SPLIT_RULE = 'batchUniqueCodeSplitRule'

export const recommendConsumableFlag = 'recommendConsumableFlag'

/// 是否开启耗材自动填充
export const ALLOW_CONSUMABLE_AUTO_FILL = 'allowConsumableAutoFill'

// toB订单允许满托开关
export const TOB_ORDER_ALLOW_FULL_PALLET = 'tob_order_allow_full_pallet'

// 页面标识
export const PAGE_TYPE = {
  CUSTOMER_CHECK: 1, // 复核打包和复核打包(新)
  SINGLE: 2, // 老版独立打包
  REBIN_CHECK: 3, // rebin复核
  SU_CHECK: 15, //打包SU复核打包
  SU_SINGLE: 16, //打包SU独立打包
  GUIDED_CHECK: 15, // 引导式打包-复核打包
  GUIDED_SINGLE: 16 // 引导式打包-独立打包
}

// 页面标识对应的阻断提示
export const BLOCK_TIP_KEY_MAP = {
  [PAGE_TYPE.CUSTOMER_CHECK]: 'hasCheckedInCustomerCheck',
  [PAGE_TYPE.SINGLE]: 'hasCheckedInSingle',
  [PAGE_TYPE.REBIN_CHECK]: 'hasCheckedInRebin',
  [PAGE_TYPE.SU_CHECK]: 'hasCheckedInSu',
  [PAGE_TYPE.SU_SINGLE]: 'hasCheckedInSu',
}